const cms = (intl, methodName) => ({
  name: intl.formatMessage({ id: 'name' }),
  title: intl.formatMessage({ id: 'name' }),
  image: intl.formatMessage({ id: 'imageOnBehalf' }),
  weight: intl.formatMessage({ id: 'weight' }),
  'brand id': intl.formatMessage({ id: 'brand' }),
  'pin to top': intl.formatMessage({ id: 'cms.pinToTop' }),
  'display type': intl.formatMessage({ id: 'cms.edm.detail.type' }),
  'release starts at': intl.formatMessage({ id: 'releaseStartsAt' }),
  'release ends at': intl.formatMessage({ id: 'releaseEndsAt' }),
  link_blocks: intl.formatMessage({ id: 'cms.linkBlock' }),
  'link_blocks.links': intl.formatMessage({ id: 'cms.link' }),
  'link_blocks.links.title': intl.formatMessage({ id: 'cms.link.name' }),
  'link_blocks.links.name': intl.formatMessage({ id: 'cms.link.name' }),
  'link_blocks.links.link_type': intl.formatMessage({ id: 'cms.link.type' }),
  'link_blocks.links.link_url': intl.formatMessage({ id: 'cms.link.path' }),
  'link_blocks.links.image': intl.formatMessage({ id: 'imageOnBehalf' }),
  'link_blocks.links.encrypt_key': intl.formatMessage({ id: 'cms.link.encryption.key' }),
  'link_blocks.links.encrypt_aes_iv': intl.formatMessage({ id: 'cms.link.encryption.iv' }),
  'link_blocks.links.parameters': intl.formatMessage({ id: 'cms.link.parameter.passedIn' }),
  'link_blocks.links.parameters.key': intl.formatMessage({ id: 'cms.link.parameter.name' }),
  'link_blocks.links.parameters.value': intl.formatMessage({ id: 'cms.link.parameter.value' }),
  'image path': intl.formatMessage({ id: 'imageOnBehalf' }),
  ...(methodName => {
    switch (methodName) {
      case 'createCmsCategory':
      case 'updateCmsCategory':
        return {
          name: intl.formatMessage({ id: 'cms.category.name' }),
          weight: intl.formatMessage({ id: 'cms.category.weight' }),
        };
      default:
        return {};
    }
  })(methodName),
});

export default cms;
